import { ChangeDetectionStrategy, Component } from '@angular/core';
import { intersection } from 'lodash';
import { isUniversalOrVectorTaggingToolObjectless } from '../../../../cross-team-shared/tools-names';
import { makeTooltipProvider } from '../../../../cross-team-shared/tooltips/tooltip-utils';
import { AbstractMainToolbar2DComponent } from '../abstract-main-toolbar/abstract-main-toolbar-2d.component';

@Component({
  selector: 'h3-main-vector-tagging-toolbar',
  templateUrl:
    '../abstract-main-toolbar/abstract-main-toolbar-2d.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [makeTooltipProvider({ position: 'right' })],
  standalone: false,
})
export class MainVectorTaggingToolbarComponent extends AbstractMainToolbar2DComponent {
  protected override getOrderedToolNames() {
    const allowedTools = this.toolsHelperService.getAllowedTools(
      this.store.state().output.name,
    );
    const orderedTools = [
      'Point',
      'Line',
      'Arrow',
      'Rectangle',
      'SliderRectangle',
      'Polygon',
      'Cuboid',
      'Keypoint',
      'Measure',
      'Zoom',
    ];

    const toolNames = this.store.state().readOnly
      ? ['Select', ...intersection(['Measure', 'Zoom'], allowedTools)]
      : ['Edit', ...intersection(orderedTools, allowedTools)];
    return toolNames.filter(isUniversalOrVectorTaggingToolObjectless);
  }
}
